import { render, staticRenderFns } from "./SocialMediaPlanDialog.vue?vue&type=template&id=99bbfaea&scoped=true&"
import script from "./SocialMediaPlanDialog.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPlanDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaPlanDialog.vue?vue&type=style&index=0&id=99bbfaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bbfaea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99bbfaea')) {
      api.createRecord('99bbfaea', component.options)
    } else {
      api.reload('99bbfaea', component.options)
    }
    module.hot.accept("./SocialMediaPlanDialog.vue?vue&type=template&id=99bbfaea&scoped=true&", function () {
      api.rerender('99bbfaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialMediaPlanDialog.vue"
export default component.exports